// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import starterReducer from "@store/Framework/Store/Starter/StarterReducer";

/* Store Custom Code - Start */
import storeReducer, { StoreActions } from "@store/Framework/Store/Store/StoreReducer";
/* Store Custom Code - End */

(reducers as any).starter = starterReducer;
(reducers as any).store = storeReducer; // Store Custom Code
